// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.view-cr-page {
  margin-bottom: 8rem;
}
.view-cr-page .first-load-card {
  border-radius: 5px;
  box-shadow: 0 1.2px 2px rgba(0, 0, 0, 0.2);
  background: white;
}
.view-cr-page .loading-card {
  background: white;
}
.view-cr-page .iybr-search-table {
  white-space: nowrap;
}
.view-cr-page .iybr-search-table .table-responsive {
  margin-bottom: unset;
}
.view-cr-page .iybr-search-table .row {
  margin-left: unset;
  margin-right: unset;
}
.view-cr-page .iybr-search-table label {
  display: inline-block;
}
.view-cr-page .iybr-search-table .pui-form-checkbox input {
  position: unset;
}
.view-cr-page .iybr-search-table .page-link {
  background-color: unset;
  border: unset;
  padding: unset;
}
.view-cr-page .iybr-search-table .inline-cell {
  display: inline-flex;
}
.view-cr-page__table {
  width: 100%;
  background-color: white;
  margin: 32px 0;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
}
.view-cr-page__table__extra-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding: 12px 16px;
  min-height: 45px;
}
.view-cr-page__table__extra-header__title .pui-headline {
  font-weight: bold;
  color: #4a4a4a;
  margin: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
